import type { ReactNode } from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';

import { store, persistor } from './index';

interface ProviderProps {
  children: ReactNode;
  loading?: ReactNode;
}

/**
 * Provider component that wraps the application with store and persistor
 * @param props Component props
 * @returns Provider component
 */
export function Provider({ children, loading = null }: ProviderProps) {
  return (
    <ReduxProvider store={store}>
      <PersistGate loading={loading} persistor={persistor}>
        {children}
      </PersistGate>
    </ReduxProvider>
  );
}
